import React from "react";
import useTranslation from "../../../hooks/useTranslation";
import "../../LocationsPage/ContainerMoreInfoPage/ContainerMoreInfoPage.scss";

const NoDataForChart = () => {
  const { t } = useTranslation("locationsPage");

  return (
    <div className="cgw-chart-loader-div no-data-container">
      <div className="no-data-icon">
        <i className="fas fa-chart-area" />
      </div>
      <div className="no-data-message-wrapper">
        <h4>{t("no_data_available")}</h4>
        <p>{t("no_data_for_selected_timeframe_description")}</p>
      </div>
      <ul>
        <li>{t("try_different_timeframe")}</li>
        <li>{t("try_different_sensors")}</li>
        <li>{t("check_device_connectivity")}</li>
      </ul>
    </div>
  );
};

export default NoDataForChart;
